import { useEffect, type ReactNode } from 'react'

interface ModalProps {
  title: ReactNode
  children?: ReactNode
  /** If provided, clicking the backdrop or pressing Escape closes the modal. */
  onClose?: () => void
  /** Footer action buttons. */
  actions?: ReactNode
}

// A centered themed modal that matches the parlor look.
export default function Modal({ title, children, onClose, actions }: ModalProps) {
  useEffect(() => {
    if (!onClose) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="modal-backdrop"
      onClick={onClose ? () => onClose() : undefined}
      role="presentation"
    >
      <div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="modal-title">{title}</h2>
        {children && <div className="modal-body">{children}</div>}
        {actions && <div className="modal-actions">{actions}</div>}
      </div>
    </div>
  )
}
